import { useState } from 'react';
import AnimatedPage from '../components/AnimatedPage';
import SmoothScrollingButton from '../components/SmoothScrollingButton';
import PartnerBar from '../components/pricingPlans/PartnerBar';
import { PRICING_PLANS } from '../constants/Plans';
import Button from '../components/common/Button';
import FeatureAccordion from '../components/pricingPlans/FeatureAccordion';
import { useNavigate } from 'react-router-dom';
import * as ROUTES from "../constants/routes";
import PricingPageJourney from '../components/modals/pricingPageJourney';

const PricingPlans = () => {
    const roles = ['Companies', 'Advisors', 'Investors'];
    let [tab, setTab] = useState("Companies");
    const navigate = useNavigate();
    const [modalData, setModalData] = useState(null);
    const [copied, setCopied] = useState(false);

    const handleCopy = (code) => {
        navigator.clipboard.writeText(code);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000); // hide after 2s
    };

    const handleModalOpen = (data) => {
        setModalData(data);
    };

    return (
        <AnimatedPage>
            <div className="poppins-font-style bg1 pricing-plan-page">
                <SmoothScrollingButton />

                <div className='df jcc fdc aic bg20 py3rem pb5rem pricing-tabs oh'>
                    <div className={`pb1rem df jcc fdc tslp op1 tty0`}>
                        <div style={{ textAlign: 'center', padding: '0 1rem' }}>
                            <p
                                className="dib fw500 fs2-125rem c15 tac" style={{ lineHeight: '62.2px' }}
                            >
                                Our <span className='c4 mx0-5rem' style={{ whiteSpace: 'nowrap' }}>Pricing</span> Plans
                            </p>
                        </div>
                    </div>

                    <div className="df aic jcc" style={{ minWidth: '400px' }}>
                        <div className="bg1 br50px w100 df aic jcsb bo65 bw1px" style={{ padding: '0.25rem' }}>
                            {roles.map((role) => (
                                <button
                                    key={role}
                                    onClick={() => setTab(role)}
                                    className={`px1rem py0-25rem cp text-sm font-medium rounded-full transition-all duration-200 ${tab === role ? 'bg3 c1 br50px' : 'c15 bg44 op40'}`}
                                >
                                    {role}
                                </button>
                            ))}
                        </div>
                    </div>


                    <div className='w100 tac'>
                        <div className={`dg ${PRICING_PLANS[tab].plans.length === 2 ? 'gtcr4' : PRICING_PLANS[tab].plans.length === 3 ? 'gtcr5' : 'gtcr6'} bg66 py2rem gg1rem w90 ma my2rem px2rem`}>
                            {
                                PRICING_PLANS[tab].plans.length === 4 ? <><div></div><div></div></> : <><div></div><div></div></>
                            }
                            {
                                PRICING_PLANS[tab].plans.map((plan, index) => {
                                    const isPaid = plan === "LITE" || plan === "PRO"
                                    return (
                                        <div key={index}
                                            className="df jcsb fdc aic bg1 br20px bo65 bw1px w100 mb1rem p1rem pr"
                                        >
                                            <div className="pr w100">
                                                {
                                                    PRICING_PLANS[tab].tag?.[plan] && <div className='df aic jcc'
                                                        style={{
                                                            width: '283px',
                                                            height: '24px',
                                                            position: 'absolute',
                                                            top: '31px',
                                                            left: '-299px'
                                                        }}>
                                                        <img src={require('../../images/pricing-page/tag.png')} alt='tag' />
                                                    </div>
                                                }
                                                {
                                                    plan === "PRO" ? <div className='df aic jcsb' style={{ height: '24px' }}>
                                                        <p className='c4 fs10px fw600 w100 tal'>MOST POPULAR </p>
                                                        {/* <img src={require('../../images/help-circle.svg')} alt='help' /> */}
                                                    </div> : <div className='df aic jcsb' style={{ height: '24px' }}></div>
                                                }
                                                {
                                                    PRICING_PLANS[tab]?.discount && PRICING_PLANS[tab]?.discount?.[plan] && <p style={{
                                                        backgroundImage: `url(${require('../../images/pricing-page/discountVector.png')})`,
                                                        minHeight: '73px',
                                                        backgroundSize: 'contain',
                                                        backgroundRepeat: 'no-repeat',
                                                        backgroundPosition: 'right center',
                                                        right: '4px',
                                                        top: '-20px',
                                                        padding: '4px',
                                                    }} className='c1 fs1rem fw600 tac pa'>
                                                        {PRICING_PLANS[tab]?.discount?.[plan]} <br></br> off
                                                    </p>
                                                }
                                                <p className={`fs1-5rem c15 fw500 tal ${PRICING_PLANS[tab]?.subTitle ? 'mb0-5rem' : 'mb2rem'}`}>
                                                    {plan}
                                                    <span className='c4 db fs12px fw400' style={{ height: '18px' }}> {PRICING_PLANS[tab]?.subTitle?.[plan] || ""}</span>
                                                </p>

                                                <p className=" c15 fw500 tal">
                                                    <span className="c3 fs2rem fw600">
                                                        {PRICING_PLANS[tab].pricing[plan]}
                                                    </span>
                                                    <span>
                                                        {
                                                            !['Custom', 'FREE'].includes(PRICING_PLANS[tab].pricing[plan]) && `/month${plan === "Portfolio PRO " && tab === "Advisors" ? "*" : ''}`
                                                        }
                                                    </span>
                                                    <span className='db c15 op60 fs14px fw400'>
                                                        {
                                                            isPaid ? <>billed annually</> : ''
                                                        }
                                                    </span>
                                                </p>
                                                <p className="fs1rem c15">{plan.description}</p>
                                            </div>
                                            <div className="df jcc fdc aic w100 mt1rem">
                                                {
                                                    'Portfolio PRO ' === plan ? <p className='tal c71 fw400 cp fs12px pr'>
                                                        *= only available through {tab === "Investors" ? 'Investor' : "Advisor"} dashboard.
                                                        <span className='c4 cp fw600' onClick={() => handleCopy(tab === "Investors" ? 'Code: INVESTOR20' : 'Code: ADVISOR20')} >
                                                            {tab === "Investors" ? ' Code: INVESTOR20 ' : ' Code: ADVISOR20 '}
                                                        </span>
                                                        {copied && <span className='pa t0 r0 bg1' style={{ padding: '4px', borderRadius: '12px' }}>(Copied!)</span>}.
                                                        Billed annually
                                                    </p> : <Button
                                                        style={{ maxHeight: "45px", paddingLeft: "8px", paddingRight: '8px', marginTop: isPaid ? '0px' : '25px' }}
                                                        customClassName='df aic jcc px0-5rem w100'
                                                        onClick={() => {
                                                            if (PRICING_PLANS[tab]?.buttonText[plan] === "Book a call") {
                                                                window.open("https://koalendar.com/e/meet-with-mark-bernstein")
                                                            } else {
                                                                navigate(ROUTES.REGISTER)
                                                            }
                                                        }}
                                                        btnType={PRICING_PLANS[tab].pricing[plan] !== 'Custom' ? "warning" : "warningOutlined"}
                                                        text={PRICING_PLANS[tab]?.buttonText[plan]}
                                                    />
                                                }

                                            </div>
                                        </div>
                                    )
                                })
                            }

                        </div>
                        <div className='w90 ma'>
                            {Object.entries(PRICING_PLANS[tab].features).map(([section, items]) => {
                                return (
                                    <FeatureAccordion
                                        tab={tab}
                                        key={section}
                                        title={section}
                                        titleInfo={section}
                                        items={items}
                                        plans={PRICING_PLANS[tab].plans}
                                        onModalOpen={handleModalOpen}
                                    />
                                )
                            })}
                        </div>
                    </div>
                </div>
                {/* detail section*/}
                <PartnerBar />
            </div>
            <PricingPageJourney modaldata={modalData} />
        </AnimatedPage>
    )
}

export default PricingPlans;



